import { isNameChangeEndorsement, DWB_LABEL_MAP } from "./lawFirmBondsHelpers";

/** Page modes for [LawFirmBondsPage.jsx](../components/LawFirmBondsPage.jsx). */
export const LAW_FIRM_BONDS_MODES = {
  APPROVE: "approve",
  CANCEL: "cancel",
  ENDORSE: "endorse",
  TEAM_MEMBER: "teamMember",
};

export function getLawFirmBondsPageConfig(mode) {
  switch (mode) {
    case LAW_FIRM_BONDS_MODES.CANCEL:
      return {
        title: "Cancel Bonds",
        subtitle:
          "View all your active bonds below. You can also request a cancellation directly from this page.",
        headerIcon: "cancel",
        showRowCancel: true,
        showRowEndorse: false,
      };
    case LAW_FIRM_BONDS_MODES.ENDORSE:
      return {
        title: "Bond Endorsements",
        subtitle:
          "Here are all the bonds that you have with us. You can apply for an endorsement here.",
        headerIcon: "endorse",
        showRowCancel: false,
        showRowEndorse: true,
      };
    case LAW_FIRM_BONDS_MODES.TEAM_MEMBER:
      return {
        title: "Bond archives (team)",
        subtitle: "Review and process bond archive requests for your team.",
        headerIcon: "plain",
        showRowCancel: false,
        showRowEndorse: false,
      };
    default:
      return {
        title: "All Bonds",
        subtitle:
          "View all your active bonds below. You can also request a cancellation or endorsement directly from this page.",
        headerIcon: "plain",
        showRowCancel: true,
        showRowEndorse: true,
      };
  }
}

/** Deceased/ward/beneficiary DWB fields valid — matches previous LawFirmCancelBonds.jsx (.trim). */
export function computeDwbOk(
  endorsementType,
  selectedBondToEndorse,
  updatedName,
  dwbFirstName,
  dwbLastName
) {
  if (endorsementType !== "Name_Change_Deceased_Ward_Beneficiary") return true;
  return DWB_LABEL_MAP[selectedBondToEndorse?.bond_type]?.single
    ? !!String(updatedName || "").trim()
    : !!String(dwbFirstName || "").trim() && !!String(dwbLastName || "").trim();
}

/** Truthy field check for Endorse page (no .trim) — preserves prior LawFirmEndorseBonds.jsx behavior. */
export function endorsePageDwbFieldsOk(selectedBondToEndorse, updatedName, dwbFirstName, dwbLastName) {
  return DWB_LABEL_MAP[selectedBondToEndorse?.bond_type]?.single
    ? updatedName
    : dwbFirstName || dwbLastName;
}

export function isInternalReleaseRiderDisabled(
  mode,
  {
    selectedBondToEndorse,
    isSubmittingEndorsement,
    endorsementType,
    nameChangeOk,
    dwbOk,
    endorseInlineDwbOk,
  }
) {
  if (!selectedBondToEndorse || isSubmittingEndorsement) return true;
  if (mode === LAW_FIRM_BONDS_MODES.APPROVE || mode === "approve") {
    return isNameChangeEndorsement(endorsementType) && !nameChangeOk;
  }
  if (mode === LAW_FIRM_BONDS_MODES.CANCEL || mode === "cancel") {
    return endorsementType === "Name_Change_Deceased_Ward_Beneficiary" && !dwbOk;
  }
  if (mode === LAW_FIRM_BONDS_MODES.ENDORSE || mode === "endorse") {
    return (
      endorsementType === "Name_Change_Deceased_Ward_Beneficiary" && !endorseInlineDwbOk
    );
  }
  return isNameChangeEndorsement(endorsementType) && !nameChangeOk;
}

export function isLawFirmEndorsementSubmitDisabled(
  mode,
  {
    isSubmittingEndorsement,
    endorsementType,
    endorsementFile,
    endorsementToCounty,
    nameChangeOk,
    dwbOk,
    endorseInlineDwbOk,
    selectedBondToEndorse,
  }
) {
  if (isSubmittingEndorsement) return true;
  if (!isNameChangeEndorsement(endorsementType) && !endorsementFile) return true;

  if (mode === LAW_FIRM_BONDS_MODES.APPROVE || mode === "approve") {
    return isNameChangeEndorsement(endorsementType) && !nameChangeOk;
  }
  if (mode === LAW_FIRM_BONDS_MODES.CANCEL || mode === "cancel") {
    return (
      (endorsementType === "Name_Change_County" && !endorsementToCounty) ||
      (endorsementType === "Name_Change_Deceased_Ward_Beneficiary" && !dwbOk)
    );
  }
  if (mode === LAW_FIRM_BONDS_MODES.ENDORSE || mode === "endorse") {
    return (
      (endorsementType === "Name_Change_County" && !endorsementToCounty) ||
      (endorsementType === "Name_Change_Deceased_Ward_Beneficiary" && !endorseInlineDwbOk)
    );
  }
  return isNameChangeEndorsement(endorsementType) && !nameChangeOk;
}
